import React from 'react'
import PlusCircle from '../../../../Assets/StorefrontIcons/PlusCircle.svg';
import MinusCircle from '../../../../Assets/StorefrontIcons/MinusCircle.svg';
import { useDispatch, useSelector } from 'react-redux';
import { updateZoomSize } from '../../../../Features/storefrontSlice';

function PreviewResize() {
    const dispatch = useDispatch();
    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    function handleZoomIn() {
        if(zoomSize < 150) {
            dispatch(updateZoomSize(zoomSize + 25));
        }
    }

    function handleZoomOut() {
        if(zoomSize > 50) {
            dispatch(updateZoomSize(zoomSize - 25));
        }
    }

    return (
        <div className="flex items-center">
            <div className="px-[10px] py-[9px]">
                <button onClick={handleZoomOut} className='size-[18px] flex items-center justify-center outline-none border-none'>
                    <img className='size-full' src={MinusCircle} alt="" />
                </button>
            </div>

            <p className='font-semibold text-[14px] leading-6 text-[#121212]'>{zoomSize}%</p>

            <div className="px-[10px] py-[9px]">
                <button onClick={handleZoomIn} className='size-[18px] flex items-center justify-center outline-none border-none'>
                    <img className='size-full' src={PlusCircle} alt="" />
                </button>
            </div>
        </div>
    );
}

export default PreviewResize;
